module.exports = __webpack_public_path__ + "img/51.65eebc0b.jpg";